const diagnosticosSocioambientais = [
    {
        path: '/diagnosticos-socioambientais/:idTerritorio?',
        name: 'DiagnosticosSocioambientais',
        meta: {
            roles: [
                'ROLE_ADMINISTRATOR',
                'ROLE_REGULAR',
                'ROLE_OPERACAO_CADASTRANTE'
            ]
        },
        component: () =>
            import(
                '@/views/diagnostico-socioambiental/DiagnosticosSocioambientais'
            )
    }
];

export default diagnosticosSocioambientais;
